import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { notificationStyles } from '~/shared/theme/theme';

interface NotificationDateMetadataProps {
  typeLabel: string;
  date: string;
  resolvedDate?: string;
  isResolved?: boolean;
}

export function NotificationDateMetadata({
  typeLabel,
  date,
  resolvedDate,
  isResolved = false,
}: NotificationDateMetadataProps) {
  const { t } = useTranslation();
  /**
   * t('notifications.created')
   * t('notifications.solved')
   */

  if (isResolved && resolvedDate) {
    return (
      <Box>
        <Typography
          variant="caption"
          color={notificationStyles.lightText}
          display="block"
        >
          {typeLabel}
        </Typography>
        <Typography
          variant="caption"
          color={notificationStyles.lightText}
          display="block"
        >
          {t('notifications.created')} {date}
        </Typography>
        <Typography
          variant="caption"
          color={notificationStyles.lightText}
          display="block"
        >
          {t('notifications.solved')} {resolvedDate}
        </Typography>
      </Box>
    );
  }

  return (
    <Typography variant="caption" color={notificationStyles.lightText}>
      {typeLabel} • {date}
    </Typography>
  );
}
